/** `integration` module DTO schemas unique keys */
export enum IntergrationDtoKeyEnum {
  /** Atrium CRM connection response body */
  ATRIUM_CONNECTION_FIND_DTO = 'integration/atrium-connection-find.dto',
  /** Atrium CRM connection create and update request body */
  ATRIUM_CONNECTION_FORM_DTO = 'integration/atrium-connection-form.dto',
  /** Atrium exchange history entry response body */
  ATRIUM_EXCHANGE_HISTORY_FIND_DTO = 'integration/atrium-exchange-history-find.dto',
  /** Atrium exchange history entries slice */
  ATRIUM_EXCHANGE_HISTORY_PAGE_DTO = 'integration/atrium-exchange-history-page.dto',
  /** Request body for API which creates deal by feedback form data from 1C Bitrix CMS side */
  BITRIX_CREATE_DEAL_BY_SITE_FEEDBACK_FORM_DTO = 'integration/bitrix-create-deal-by-site-feedback-form.dto',
  /** 1C ERP database connection credentials test result */
  CONNECTION_1C_CREDENTIALS_TEST_RESULT_DTO = 'integration/connection-1c-credentials-test-result.dto',
  /** 1C ERP database connection credentials base data */
  CONNECTION_1C_CREDENTIALS_DTO = 'integration/connection-1c-credentials.dto',
  /** 1C ERP database connection credentials response body */
  CONNECTION_1C_FIND_DTO = 'integration/connection-1c-find.dto',
  /** 1C ERP database connection credentials create or update request body */
  CONNECTION_1C_FORM_DTO = 'integration/connection-1c-form.dto',
  /** 1C ERP database connection credentials list API query parameters */
  CONNECTION_1C_QUERY_DTO = 'integration/connection-1c-query.dto',
  /** 1C ERP database developer console request body */
  CONNECTION_1C_CONSOLE_FORM_DTO = 'integration/connection-1c-console-form.dto',
  /** 1C ERP database developer console response body */
  CONNECTION_1C_CONSOLE_RESULT_DTO = 'integration/connection-1c-console-result.dto',
  /** Mailbox create and update API request body */
  EMAIL_FORM_DTO = 'integration/email-form.dto',
  /** Mailbox response body */
  EMAIL_FIND_DTO = 'integration/email-find.dto',
  /** Mailbox SMTP test API response body */
  EMAIL_TEST_SMTP_RESULT_DTO = 'integration/email-test-smtp-result.dto',
  /** ERP 1C exchange log history base filters */
  ERP_1C_EXCHANGE_LOG_FILTERS_DTO = 'integration/erp-1c-exchange-log-filters.dto',
  /** ERP 1C exchange log entry response body */
  ERP_1C_EXCHANGE_LOG_FIND_DTO = 'integration/erp-1c-exchange-log-find.dto',
  /** ERP 1C exchange log history API response body */
  ERP_1C_EXCHANGE_LOG_PAGE_DTO = 'integration/erp-1c-exchange-log-page.dto',
  /** ERP 1C exchange log history API query parameters */
  ERP_1C_EXCHANGE_LOG_QUERY_DTO = 'integration/erp-1c-exchange-log-query.dto',
  /** ERP 1C exchange log subtotal API response item */
  ERP_1C_EXCHANGE_LOG_SUBTOTAL_ITEM_DTO = 'integration/erp-1c-exchange-log-subtotal-item.dto',
  /** ERP 1C exchange log subtotal API query parameters */
  ERP_1C_EXCHANGE_LOG_SUBTOTAL_QUERY_DTO = 'integration/erp-1c-exchange-log-subtotal-query.dto',
  /** Plaftorma OFD CRM connection create request body */
  PLATFORMA_OFD_CONNECTION_FORM_DTO = 'integration/platforma-ofd-connection-form.dto',
  /** "Leber" BRS task creation form request body */
  LEBER_BRS_TASK_FORM_DTO = 'integration/leber-brs-task-form.dto',
  /** Leber BRS task list API request body with filters */
  LEBER_BRS_TASK_LIST_FILTERS_DTO = 'integration/leber-brs-task-list-filters.dto',
  /** Leber BRS task list API item response body */
  LEBER_BRS_TASK_LIST_ITEM_DTO = 'integration/leber-brs-task-list-item.dto',
  /** Leber BRS task order response body */
  LEBER_BRS_TASK_ORDER_DTO = 'integration/leber-brs-task-order.dto',
  /** Leber BRS task find one API response body */
  LEBER_BRS_TASK_DTO = 'integration/leber-brs-task.dto',
  /** "Leber" deal creation API request body */
  LEBER_CREATE_DEAL_FORM_DTO = 'integration/leber-create-deal-form.dto',
  /** "Leber" documents list API response body item */
  LEBER_GET_DOCUMENTS_ITEM_DTO = 'integration/leber-get-documents-item.dto',
  /** "Leber" documents list API query parameters */
  LEBER_GET_DOCUMENTS_QUERY_DTO = 'integration/leber-get-documents-query.dto',
  /** MainSMS account response body */
  MAIN_SMS_ACCOUNT_FIND_DTO = 'integration/main-sms-account-find.dto',
  /** MainSMS account create and update APIs request body */
  MAIN_SMS_ACCOUNT_FORM_DTO = 'integration/main-sms-account-form.dto',
  /** MainSMS accounts list API query parameters */
  MAIN_SMS_ACCOUNT_QUERY_DTO = 'integration/main-sms-account-query.dto',
  /** 1C ERP plugin file edition APIs URL parameters */
  PLUGIN_1C_EDIT_PARAMS_DTO = 'integration/plugin-1c-edit-params.dto',
  /** Plugin description response body */
  PLUGIN_1C_FIND_DTO = 'integration/plugin-1c-find.dto',
  /** 1C ERP plugin file reading APIs URL parameters */
  PLUGIN_1C_READ_PARAMS_DTO = 'integration/plugin-1c-read-params.dto',
  /** Amo credentails response body */
  AMO_CREDENTAILS_FIND_DTO = 'integration/amo-credentails-find.dto',
  /** Amo credentails create API request body */
  AMO_CREDENTAILS_FORM_DTO = 'integration/amo-credentails-form.dto',
  /** Amo deal status response body */
  AMO_DEAL_STATUS_FIND_DTO = 'integration/amo-deal-status-find.dto',
  /** Amo pipeline response body */
  AMO_PIPELINE_FIND_DTO = 'integration/amo-pipeline-find.dto',
  /** Amo deal status create or update response body */
  AMO_DEAL_STATUS_FORM_DTO = 'integration/amo-deal-status-form.dto',
  /** Bind gmail to user response body */
  BIND_GMAIL_TO_USER_DTO = 'integration/bind-gmail-to-user.dto',
  /** Megaplan credentails response body */
  MEGAPLAN_CREDENTAILS_FIND_DTO = 'integration/megaplan-credentails-find.dto',
  /** Megaplan credentails create or update response body */
  MEGAPLAN_CREDENTAILS_FORM_DTO = 'integration/megaplan-credentails-form.dto',
  /** Megaplan program response body */
  MEGAPLAN_PROGRAM_FIND_DTO = 'integration/megaplan-program-find.dto',
  /** Megaplan program create or update body */
  MEGAPLAN_PROGRAM_FORM_DTO = 'integration/megaplan-program-form.dto',
  /** Megaplan status response body */
  MEGAPLAN_STATUS_FIND_DTO = 'integration/megaplan-status-find.dto',
}
